import React, { useContext, useRef } from 'react';
import { Typography, List, ListItem } from '@mui/material';
import * as S from './Styled';
import { useAuth } from '../../context/AuthContext';
import { CouponsContext } from '../../context/CouponsContext';
import Cupom from '../Modal/Cupom/Cupom';
import useCouponRedirect from '../../hooks/useCouponRedirect';
import useUTMParams from '../../hooks/useUTMParams';
import useUserData from '../../hooks/useUserData';
import { useAlert } from '../../context/AlertContext';
import CouponCard, { getCashbackPercentage } from './CouponCard';
import {useCouponRoute}  from '../../hooks/useCouponRoute';

const Coupons = ({ categorie, pagination, genericCoupons, noTutorial }) => {
    const couponListRef = useRef(null);
    const { getcouponRedirect } = useCouponRedirect();
    const { utmSource, utmCampaign } = useUTMParams();
    const { user } = useUserData();
    const { showAlert } = useAlert();
    const { isAuthenticated } = useAuth(+categorie.incentiveId);
    const context = useContext(CouponsContext);
    const coupons = genericCoupons ?? context.coupons;

    const { selectedCoupon, isModalOpen, openCoupon, closeCoupon } = useCouponRoute(coupons);

    const scrollToCoupons = () => {
        couponListRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const renderedCoupons = (coupons.data || []).map((coupon) => (
        <CouponCard
            key={coupon?.id}
            id={coupon?.id}
            coupon={coupon}
            categorie={categorie}
            uppercaseTitle
            isAuthenticated={isAuthenticated}
            openCoupon={openCoupon}
            getcouponRedirect={getcouponRedirect}
            utmSource={utmSource}
            utmCampaign={utmCampaign}
            userId={user?.id}
            incentiveId={categorie?.incentive_id}
            slug={categorie?.slug}
            showAlert={showAlert}
        />
    ));

    return (
        <S.ContainerHowToUse>
        <S.CouponList ref={couponListRef}>{renderedCoupons}</S.CouponList>

        {pagination && React.cloneElement(pagination, { onPageChange: scrollToCoupons })}


        {noTutorial? null: (
                    <S.HowToUseSection>
            <h2>COMO USAR UM CUPOM:</h2>
            <Typography sx={{ fontSize: '14px' }}>
            É bem fácil usar um cupom de desconto através do MeuCupom.com e nós vamos te explicar!
            </Typography>
            <List component="ol">
            {[1, 2, 3, 4].map((num) => (
                <ListItem key={num} sx={{ paddingLeft: 0, marginLeft: 0 }}>
                <Typography sx={{ fontSize: '14px' }}>
                    <strong>{num}.</strong>{' '}
                    {[
                    'Achou um bom cupom de desconto? Clique em “Pegar Cupom”. Ao clicar, uma janela será aberta.',
                    'Dentro da janela, clique no botão “Copiar código e ir para a loja” e o código do cupom de desconto já está pronto para ser colado no carrinho de compras enquanto te redirecionamos para a oferta ou produto dentro da loja.',
                    'Ao final das suas compras, dentro de seu carrinho de compras, procure o campo de cupons/vale e cole o código do cupom de desconto.',
                    'O desconto será reduzido do valor final assim que o código for inserido no campo correspondente. Prontinho, você já está economizando!',
                    ][num - 1]}
                </Typography>
                </ListItem>
            ))}
            </List>
        </S.HowToUseSection>
        ) }



        {isModalOpen && selectedCoupon && (
            <Cupom
            open={isModalOpen}
            handleClose={closeCoupon}
            couponId={selectedCoupon.id}
            name={selectedCoupon.name}
            slug={selectedCoupon.slug}
            cupomLink={selectedCoupon.linkUrl}
            cupomCode={selectedCoupon.code}
            description={selectedCoupon.description}
            clicks={selectedCoupon.clicks}
            endDate={selectedCoupon.endDate}
            storeName={selectedCoupon.store?.name}
            storeSlug={selectedCoupon.store?.slug}
            cashback={getCashbackPercentage(selectedCoupon.store, categorie)}
            incentiveId={categorie.incentive_id}
            userId={user?.id}
            />
        )}
        </S.ContainerHowToUse>
    );
};

export default Coupons;